export const SET_AUTH_DATA = 'SET_AUTH_DATA'
export const UNSET_AUTH_DATA = 'UNSET_AUTH_DATA'
export const DATA_ERROR_401 = 'DATA_ERROR_401'
export const SEARCH_CRM_INFO = 'SEARCH_CRM_INFO'
export const SEARCH_TYPE_DOC= 'SEARCH_TYPE_DOC'
export const SEARCH_CRM_CONTRACT= 'SEARCH_CRM_CONTRACT'

